// Simple event emitter for global app updates
class AppEventEmitter {
  private orderListeners: Array<() => void> = [];
  private productListeners: Array<() => void> = [];

  subscribeToOrders(callback: () => void) {
    this.orderListeners.push(callback);
    
    // Return unsubscribe function
    return () => {
      this.orderListeners = this.orderListeners.filter(listener => listener !== callback);
    };
  }

  subscribeToProducts(callback: () => void) {
    this.productListeners.push(callback);
    
    // Return unsubscribe function
    return () => {
      this.productListeners = this.productListeners.filter(listener => listener !== callback);
    };
  }

  emitOrderUpdate() {
    console.log('🔔 [APP-EVENTS] Emitting order update to', this.orderListeners.length, 'listeners');
    this.orderListeners.forEach(callback => {
      try {
        callback();
      } catch (error) {
        console.error('[AppEvents] Error in order listener:', error);
      }
    });
  }

  emitProductUpdate() {
    console.log('🔔 [APP-EVENTS] Emitting product update to', this.productListeners.length, 'listeners');
    this.productListeners.forEach(callback => {
      try {
        callback();
      } catch (error) {
        console.error('[AppEvents] Error in product listener:', error);
      }
    });
  }
}

export const appEvents = new AppEventEmitter();

// For backward compatibility
export const orderEvents = {
  subscribe: appEvents.subscribeToOrders.bind(appEvents),
  emit: appEvents.emitOrderUpdate.bind(appEvents)
};

// Helper functions
export const forceOrderBannerRefresh = () => {
  console.log('🔔 [APP-EVENTS] Forcing order banner refresh');
  appEvents.emitOrderUpdate();
};

export const forceProductListRefresh = () => {
  console.log('🔔 [APP-EVENTS] Forcing product list refresh');
  appEvents.emitProductUpdate();
};
